import React, { useState } from 'react';
import { BrowserRouter, Navigate, Route, Routes} from 'react-router-dom';
import { useAuth } from './utility/useAuth';
import ProtectedRoutes from './services/ProtectedRoute';
import Dashboard from './pages/dashboard/Dashboard';
import Login from './login/Login';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const role = localStorage.getItem('role');
  return (

    <BrowserRouter>
      <AuthWrapper setIsAuthenticated={setIsAuthenticated} />
      <Routes>
        <Route path={'/'} element={isAuthenticated ? (<Navigate to={'/meetings'} />) : (<Login />)} />
        <Route element={<ProtectedRoutes />}>
              <Route exact path="/meetings" element={<Dashboard />} />
        </Route>
      </Routes>
    </BrowserRouter>

  );
}
function AuthWrapper({ setIsAuthenticated }) {
  useAuth(setIsAuthenticated);
  return null;
}
export default App;